import _ from 'lodash';
import * as utils from '../../../util/utils';
import {
    RECEIVE_FILTER_IN_RESULTS,
    REMOVE_FILTER_IN_RESULTS,
    RECEIVE_AGGREGATE_FILTERS,
    CLEAR_ALL_FILTERS_IN_RESULTS
} from '../../../actions/selectedFilter/inResultsActions';

const InResultsReducer = (state = [], action) => {
    Object.freeze(state);
    let newState = state.slice();

    switch (action.type) {
        case RECEIVE_AGGREGATE_FILTERS:
            return action.filters;

        case RECEIVE_FILTER_IN_RESULTS:
            newState.push(action.filter);
            return newState;

        case REMOVE_FILTER_IN_RESULTS:
            return utils.deleteFromArray(newState, action.filter);
        
        case CLEAR_ALL_FILTERS_IN_RESULTS:
            return [];

        default:
            return state;
    }
};

export default InResultsReducer;